<template>
    <div>
        <div v-if="!isEditing" class="editor" @click="isEditing = !isEditing">{{text}}</div>
        <div v-if="isEditing">
            <textarea name="text" id="text" rows="4" v-model="editedText" class="w-100" ref="textArea"></textarea>
            <button type="button" class="btn btn-success btn-sm" @click.prevent="onSave">Speichern</button>
            <button type="button" class="btn btn-link ml-1" @click.prevent="isEditing = false">Abbrechen</button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "LongTextEditor",

        data: function() {
            return {

                isEditing: false,
                textEdit: ''
            }
        },

        watch: {

            isEditing: function(val) {

                if (val) {

                    this.$nextTick()
                        .then(() => {
                            this.$refs.textArea.focus();
                        });
                }
            }
        },
        methods: {
            onSave() {

                this.isEditing = false;
                this.$emit('update', this.textEdit);
            }
        },
        props: {
            text: {
                type: String,
                required: true
            },
        },

        computed: {

            editedText: {

                get: function() {
                    return this.text;
                },

                set: function(newValue) {
                    this.textEdit = newValue;
                }
            }
        }
    }
</script>

<style scoped lang="scss">

    .editor:hover {

        background-color: #f7f8fa;
    }
</style>